import { useEffect, useState } from "react";
import { Upload, FileText, Download, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import api from "@/lib/apiClient";
import { toast } from "sonner";

export default function DocumentVault() {
  const [docs, setDocs] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/portal/documents").then((r) => setDocs(r.data.documents)).catch(() => {});
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    const fd = new FormData();
    fd.append("file", f);
    fd.append("label", f.name);
    setBusy(true);
    try { await api.post("/portal/documents", fd, { headers: { "Content-Type": "multipart/form-data" } }); toast.success("Document uploaded"); load(); }
    catch { toast.error("Upload failed"); } finally { setBusy(false); e.target.value = ""; }
  };

  const download = async (d) => {
    try {
      const r = await api.get(`/files/${d.storage_path}`, { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a"); a.href = url; a.download = d.original_filename || "file"; a.click();
      URL.revokeObjectURL(url);
    } catch { toast.error("Download failed"); }
  };

  return (
    <div data-testid="document-vault">
      <label className="inline-flex items-center gap-2 cursor-pointer bg-blue-900 hover:bg-blue-950 text-white text-sm font-medium rounded-lg px-4 py-2.5" data-testid="doc-upload-label">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />} Upload document
        <input type="file" className="hidden" onChange={upload} disabled={busy} data-testid="doc-upload-input" accept=".pdf,.png,.jpg,.jpeg,.webp,.doc,.docx" />
      </label>
      <div className="mt-4 space-y-2">
        {docs.length === 0 && <p className="text-sm text-slate-400">No documents yet. Upload your ID, certifications or care documents.</p>}
        {docs.map((d) => (
          <div key={d.id} className="flex items-center justify-between bg-white border border-slate-200 rounded-xl p-3" data-testid={`doc-${d.id}`}>
            <div className="flex items-center gap-2 min-w-0"><FileText className="w-4 h-4 text-teal-600 shrink-0" /><span className="text-sm text-slate-700 truncate">{d.original_filename}</span></div>
            <button onClick={() => download(d)} className="text-teal-600 hover:text-teal-800 shrink-0" data-testid={`doc-download-${d.id}`}><Download className="w-4 h-4" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
